import { RequestConfig } from '@/interface'

const PRIFIX = '/fpgl/order/'
const orderConfig: RequestConfig = {
  // 保存订单信息
  orderBcddxx: {
    url: `${PRIFIX}bcddxx`,
    method: 'post'
  },
  // 标记为不开票
  orderBjwbkp: {
    url: `${PRIFIX}bjwbkp`,
    method: 'post'
  },
  // 拆分开票保存
  orderCfkpbc: {
    url: `${PRIFIX}cfkpbc`,
    method: 'post'
  },
  // 撤销不开票
  orderCxbkp: {
    url: `${PRIFIX}cxbkp`,
    method: 'post'
  },
  // 删除
  orderDels: {
    url: `${PRIFIX}dels`,
    method: 'post'
  },
  // 订单详情
  orderDetail: {
    url: `${PRIFIX}detail`,
    method: 'post'
  },
  // 合并开票详情
  orderHbkp: {
    url: `${PRIFIX}hbkp`,
    method: 'post'
  },
  // 合并开票提交
  orderHbkptj: {
    url: `${PRIFIX}hbkptj`,
    method: 'post'
  },
  // 订单提交开票
  orderTjkp: {
    url: `${PRIFIX}tjkp`,
    method: 'post'
  },
  // 单张提交开票
  tjkpSingle: {
    url: `${PRIFIX}tjkpSingle`,
    method: 'post'
  },
  // 开票信息录入
  qrCodeAdd: {
    url: `${PRIFIX}qrCodeAdd`,
    method: 'post'
  },
  // 订单列表
  orderQueryPageList: {
    url: `${PRIFIX}queryPageList`,
    method: 'post'
  },
  // 开票信息前置参数
  qrCodeInfo: {
    url: `${PRIFIX}qrCodeInfo`,
    method: 'post'
  },
  // 订单发票信息
  ddFpxx: {
    url: `${PRIFIX}ddFpxx`,
    method: 'post'
  },
  // 作废重来
  cxkj: {
    url: `${PRIFIX}cxkj`,
    method: 'post'
  },
  // 修改购方数据
  xgGfxx: {
    url: `${PRIFIX}xgGfxx`,
    method: 'post'
  },
  // 搜索结果统计
  searchReport: {
    url: `${PRIFIX}searchReport`,
    method: 'post'
  },
  // 一键提交
  searchSubmit: {
    url: `${PRIFIX}searchSubmit`,
    method: 'post'
  },
  // 一键提交结果
  searchSubmitResult: {
    url: `${PRIFIX}searchSubmitResult`,
    method: 'post'
  },
  // 导出
  ddExpert: {
    url: `${PRIFIX}expert`,
    method: 'post'
  },
  // 订单状态
  qrCodeAddStatus: {
    url: `${PRIFIX}qrCodeAddStatus`,
    method: 'post'
  },
  // 订单发票
  invoiceDownInfo: {
    url: `${PRIFIX}invoiceDownInfo`,
    method: 'post'
  },
  // 快捷赋码列表
  findKjfmList: {
    url: `${PRIFIX}findKjfmList`,
    method: 'post'
  },
  // 批量快捷赋码更新
  batchUpdateSsflbm: {
    url: `${PRIFIX}batchUpdateSsflbm`,
    method: 'post'
  }
}
export default orderConfig
